import { getGroupData } from '../api/supabase/codeService';

export const INTEREST_FREE_INSTALLMENT_DEFAULT = `[무이자 할부 안내]

농협 2~6개월
국민/롯데/비씨/우리/하나 2~5개월
삼성/신한/현대 2~3개월

* 무이자 12개월 이벤트 진행중!
- 영어교실 코스 등록 시 선착순 적용
- 고객센터로 신청해 주세요. ☎1800-0588`;

const INTEREST_FREE_INSTALLMENT_KEY = 'INTEREST_FREE_INSTALLMENT';

/**
 * 텍스트의 빈 줄을 공백 문자로 대체하여 보존하는 함수
 */
const preserveEmptyLines = (text: string): string => {
  return text.replace(/\n\n/g, '\n\u00A0\n');
};

/**
 * supabase에서 무이자 할부 텍스트를 가져오는 함수
 * @returns 무이자 할부 텍스트
 */
export const getInterestFreeInstallmentMessage = async (): Promise<string> => {
  try {
    const res = await getGroupData(INTEREST_FREE_INSTALLMENT_KEY);
    const message = res[INTEREST_FREE_INSTALLMENT_KEY];

    // 데이터가 없거나 빈 문자열인 경우 기본값 사용
    if (!message || message.trim() === '') {
      console.warn('무이자 할부 정보가 비어있어 기본값을 사용합니다.');
      return preserveEmptyLines(INTEREST_FREE_INSTALLMENT_DEFAULT);
    }

    return preserveEmptyLines(message);
  } catch (error) {
    console.error('무이자 할부 정보를 가져오는데 실패했습니다:', error);
    return preserveEmptyLines(INTEREST_FREE_INSTALLMENT_DEFAULT);
  }
};
